import styled from 'styled-components';
import { OBannerFeatureLayout, OBannerFeatureContentAlignment } from './OBannerFeature.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

interface WrapperProps {
  layout: OBannerFeatureLayout;
}

interface ContentSectionProps {
  contentAlignment?: OBannerFeatureContentAlignment;
}

interface ButtonWrapperProps {
  contentAlignment?: OBannerFeatureContentAlignment;
}

export const Wrapper = styled.div<WrapperProps>`
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  padding-block: 3rem;
  gap: ${spacers?.spacers?.[5] ?? '2rem'};

  @media (min-width: 768px) {
    flex-direction: ${({ layout }) => (layout === OBannerFeatureLayout.Reverse ? 'row-reverse' : 'row')};
  }

  @media (min-width: 992px) {
    gap: 4rem;
  }
`;

export const ContentSection = styled.div<ContentSectionProps>`
  display: flex;
  flex: 1 0 0;
  justify-content: ${({ contentAlignment }) =>
    contentAlignment === OBannerFeatureContentAlignment.Center ? 'center' : 'flex-start'};
  align-items: center;
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacers?.spacers?.[4] ?? '1.5rem'};
`;

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  justify-content: ${({ contentAlignment }) =>
    contentAlignment === OBannerFeatureContentAlignment.Center ? 'center' : 'flex-start'};
`;

export const ImageSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .feature-image {
    border-radius: var(--t-images-border-radius, 14px);
  }
`;
